import { useMemo } from 'react';

import {
  BoxFormControlViewModel,
  TabsPaneFormControlViewModel,
} from '../../../services/form/view-model/FormControlViewModel';
import UniqueId from '../../../services/uid/UniqueId';
import { useAppSelector } from '../../../store/hooks';
import { getFormControls } from '../../../store/selectors/form';

import { useFormContext } from './FormContext';

export const useFormGroupErrors = (
  formId: UniqueId,
  groupControlName: string
): { errors: Set<string> } => {
  const { errors: contextErrors } = useFormContext();
  const formControls = useAppSelector(state => getFormControls(state, formId));
  const groupControl = formControls[groupControlName] as
    TabsPaneFormControlViewModel | BoxFormControlViewModel;

  const errors = useMemo(() => {
    const resultErrors = new Set<string>();

    const hasError = (controlName: string): boolean => {
      const formControl = formControls[controlName];
      if ('children' in formControl) {
        return formControl.children.some(child => hasError(child));
      } else {
        return contextErrors.has(controlName);
      }
    };

    groupControl.children.forEach(child => {
      if (hasError(child)) {
        resultErrors.add(child);
      }
    });

    return resultErrors;
  }, [contextErrors, formControls, groupControl]);

  return { errors };
};
